export function getNestedPageId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('nested_page_id');
}

export function setNestedPageId(nestedPageId: string, pushHistory = false) {
  if (pushHistory) {
    const url = new URL(window.location.href);
    url.searchParams.set('nested_page_id', nestedPageId);
    window.history.pushState({}, '', url);

    return url.searchParams;
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('nested_page_id', nestedPageId);

    return urlParams;
  }
}
